import React from 'react'
import {LifeServiciosItem} from './LifeServiciosItem'

function LifeServicios(props) {
  const displayItems = (props) => {
    const servicios = props.servicios

    if (servicios.length > 0) {
      return servicios.map((servicio, index) => {
        return <LifeServiciosItem key={index} servicio={servicio} />
      })
    } else {
      return <h3>No hay servicios</h3>
    }
  }

  return <>{displayItems(props)}</>
}

export {LifeServicios}
